import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NativeClientService } from '../../shared/services/native-client.service';

/**
 * Guard that checks if the user is using a native client.
 */
export const nativeClientGuard: CanActivateFn = (): boolean => {
  const nativeClientService = inject(NativeClientService);
  const router = inject(Router);

  // If it's not a native client redirect to dashboard
  if (!nativeClientService.isNative) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
